import { useEffect } from 'react';
import { createDeepCompareEffect } from '../createDeepCompareEffect';
export default createDeepCompareEffect(useEffect);
//# sourceMappingURL=index.js.map